import { QueryApiOptions } from '../../types/types';
import { AxiosRequestConfig } from 'axios';
import { axiosClient } from '@as-react/common-utils';
import { createUrl } from '../../utils/createUrl';
import { ShopStockProduct, StockSkuShop } from '@as-react/common-types';

const urlMapping = {
  availabilityForCurrentStore: {
    client: 'api/aem/stock/public/store/product/{market}',
    // server: '/public/stock/store/product/{ds}',
  },
  availabilityForAllStores: {
    client: 'api/aem/stock/public/store/sku/{market}',
    // server: '/public/stock/store/sku/{ds}',
  },
} as const;

export type ProductAvailabilityForCurrentStoreParams = {
  storeNumber?: string;
  storeId?: number;
  productId: string;
};

export type ProductAvailabilityForCurrentStoreResponse = ShopStockProduct | null;

export const getProductAvailabilityForCurrentStore = async (
  { servicesEndpoint, defaultRequestParams, isServer }: QueryApiOptions,
  { storeNumber, storeId, productId }: ProductAvailabilityForCurrentStoreParams
): Promise<ProductAvailabilityForCurrentStoreResponse> => {
  const url = createUrl(servicesEndpoint, urlMapping.availabilityForCurrentStore, isServer, {
    market: defaultRequestParams.market,
  });

  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: 'GET',
    params: {
      ...defaultRequestParams,
      productId,
      ...(storeNumber && { storeNumber }),
      ...(storeId && { storeId }),
    },
  };

  const result = await axiosClient.request(axiosConfig);
  return result.data;
};

export type ProductAvailabilityForAllStoresParams = {
  skuId: number;
};

export type ProductAvailabilityForAllStoresResponse = Array<StockSkuShop>;

export const getProductAvailabilityForAllStores = async (
  { servicesEndpoint, defaultRequestParams, isServer }: QueryApiOptions,
  { skuId }: ProductAvailabilityForAllStoresParams
): Promise<ProductAvailabilityForAllStoresResponse> => {
  const url = createUrl(servicesEndpoint, urlMapping.availabilityForAllStores, isServer, {
    market: defaultRequestParams.market,
  });
  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: 'GET',
    params: {
      ...defaultRequestParams,
      skuId,
    },
  };

  const result = await axiosClient.request(axiosConfig);
  return result.data;
};
